module.exports = __webpack_public_path__ + "static/media/acmemarkets.3243d0be.svg";